import { client } from "../client"
import Alpine from '../alpine.js'

Alpine.data('clientPrivateNotes', (clientId, notes) => ({
  clientId,
  notes,
  isSaving: false,
  showSavedSuccess: false,
  undoStack: [],
  undo () {
  },
  init () {
    this.$watch('notes', (val) => {
      this.isSaving = true
      client.patch(`/clients/${clientId}/private_notes`, { private_notes: val })
        .then(() => {
          this.isSaving = false
          this.showSavedSuccess = true
          setTimeout(() => { this.showSavedSuccess = false }, 1000)
        })
        .catch((err) => {
          this.isSaving = false
          this.$dispatch('add-message', { type: 'error', title: 'Unable to save note.' })
        })
    })
  }
}))
